import React from "react";

const moduleData = [
  {
    id: 1,
    title: "Introduction to International Relations",
    description:
      "Explore key theories, concepts, and frameworks in international relations, focusing on global cooperation, conflict resolution, power dynamics, and governance in an interconnected world.",
  },
  {
    id: 2,
    title: "Foreign Office Leadership",
    description:
      "Develop leadership and strategic decision-making skills tailored for senior officials in foreign offices, focusing on diplomacy, policy implementation, and governance.",
  },
  {
    id: 3,
    title: "Climate and Environmental Diplomacy",
    description:
      "Addressing climate change, environmental sustainability, and global collaboration frameworks.",
  },
  {
    id: 4,
    title: "Migration Management and Security",
    description:
      "Analysing migration policies and strategies for managing global and regional migration challenges.",
  },
  {
    id: 5,
    title: "Gender in Diplomacy and Leadership",
    description:
      "Examining gender issues in diplomacy and leadership, focusing on inclusivity and empowerment.",
  },
  {
    id: 6,
    title: "Human Rights and Good Governance",
    description:
      "Exploring the intersection of human rights, governance frameworks, and the role of law in diplomacy.",
  },
  {
    id: 7,
    title: "International Relations Foundations",
    description:
      "Understand key theories, concepts, and practices in international relations, focusing on global cooperation, conflict resolution, and governance frameworks.",
  },
  {
    id: 8,
    title: "Study Tours",
    description:
      "Visits to European Union institutions, UN agencies, and regional organisations to observe diplomatic practices and governance in action.",
  },
];

const Modules = () => {
  return (
    <div className="bg-[#39699D]">
      <div className="mx-auto max-w-6xl md:p-10 p-3 space-y-3">
        <div>
          <p className="text-white font-bold text-lg md:text-xl">Modules</p>
        </div>

        <div className="bg-sdbodywhite h-0.5 w-10"></div>
        <div className="space-y-2">
          {moduleData.map((module, index) => (
            <div
              key={module.id}
              className="p-2 rounded-lg border-2 border-white space-y-2"
            >
              <div className="p-2 rounded-tl-md bg-[#B8DAFF] inline-block text-sm md:text-base">
                <p>
                  {index + 1}. {module.title}
                </p>
              </div>

              <div>
                <p className="text-white text-sm md:text-base">
                  {module.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Modules;
